import { useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    clientSftp,
    clientSftpLoadingStatus,
    getClientSftp,
    oneClient,
    updateClientSftp,
} from '../../../../redux/slices/clientsSlice';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { Button, Empty } from 'antd';

import ClientSftpForm from './ClientSftpForm/ClientSftpForm';
import LocalLoader from '../../../../components/LocalLoader/LocalLoader';
import { Edit } from '../../../../components/Svg/Svg';
import ClientSftpTable from './ClientSftpTable/ClientSftpTable';

export default function ClientSftpSubPage() {
    const dispatch = useDispatch();
    const client = useSelector(oneClient);
    const sftpData = useSelector(clientSftp);
    const clientSftpStatus = useSelector(clientSftpLoadingStatus);
    const [data, setData] = useState({
        name: '',
        base_url: '',
        login: '',
        password: '',
        create_account_b2c_url: '/api/v3/account',
        create_account_b2b_url: '/api/v3/account',
        mail_from_address: '',
        mail_from_name: '',
        mail_recipient: '',
        sftp_host: '',
        sftp_port: '',
        sftp_username: '',
        sftp_password: '',
        sftp_directory: null,
    });
    const [isDisabledFields, setIsDisabledFields] = useState({
        b2cUrl: true,
        b2bUrl: true,
    });
    const [errors, setErrors] = useState({});
    const [view, setView] = useState('view');

    useEffect(() => {
        if (!client.client_uid) {
            return;
        }

        dispatch(getClientSftp({ id: client.client_uid }));
    }, [client, dispatch]);

    useEffect(() => {
        if (!sftpData.id) {
            return;
        }

        setData(sftpData);

        // is this action necessary if we have a new client that does not have sftp, since the form is not cleared
        // when changing  the client and keeps the fields of the previous client
        return () => {
            setData({
                create_account_b2c_url: '/api/v3/account',
                create_account_b2b_url: '/api/v3/account',
            });
        };
    }, [sftpData, sftpData.id]);

    const onEditClick = () => {
        setView('edit');
    };

    const onCancelButtonClick = () => {
        if (sftpData.id) {
            setData(sftpData);
        } else {
            setData({
                create_account_b2c_url: '/api/v3/account',
                create_account_b2b_url: '/api/v3/account',
            });
        }

        setView('view');
        setErrors({});
    };
    const onHandleChange = useCallback(
        (e) => {
            e.preventDefault();
            const { name, value } = e.target;

            setData({ ...data, [name]: value });
        },
        [data],
    );

    const onSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        try {
            await dispatch(
                updateClientSftp({ id: client.client_uid, body: data }),
            ).unwrap();
            dispatch(getClientSftp({ id: client.client_uid }));
            toast.success('Changes saved successfully');
            setErrors({});
            setView('view');
        } catch (error) {
            setErrors(error.errors);
        }
    };

    if (clientSftpStatus === 'loading') return <LocalLoader />;

    return (
        <>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - SFTP`}</title>
            </Helmet>

            <div className="details-table-wrapper">
                <div className="table-top-pannel">
                    <div className="table-top-pannel__info">
                        <h2 className="table-top-pannel__title">
                            SFTP details
                        </h2>
                    </div>
                    {view === 'view' && (
                        <Button
                            type="primary"
                            size="large"
                            onClick={onEditClick}
                        >
                            {sftpData.id && <Edit />}
                            <span
                                style={{
                                    marginLeft: `${sftpData.id ? '8px' : '0'}`,
                                }}
                            >
                                {sftpData.id ? 'Edit' : 'Add'}
                            </span>
                        </Button>
                    )}
                    {view === 'edit' && (
                        <div className="details-table__buttons-wrapper">
                            <button
                                className="details-table__button modal__button-cancel"
                                onClick={onCancelButtonClick}
                            >
                                Cancel
                            </button>
                            <button
                                className="details-table__button modal__button-accept"
                                type="button"
                                onClick={onSubmit}
                            >
                                Save
                            </button>
                        </div>
                    )}
                </div>
                {view === 'view' &&
                    (sftpData.id ? (
                        <ClientSftpTable data={data} />
                    ) : (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    ))}

                {view === 'edit' && (
                    <ClientSftpForm
                        clientId={client.client_uid}
                        onChange={onHandleChange}
                        errors={errors}
                        setIsDisabledFields={setIsDisabledFields}
                        isDisabledFields={isDisabledFields}
                        data={data}
                    />
                )}
            </div>
        </>
    );
}
